<template>
  <div class="profile-user-view">
    <keep-alive>
      <component :is="componentName" />
    </keep-alive>
  </div>
</template>

<script>
import { mdiCheckCircleOutline } from '@mdi/js';
import PersonProfileType from '@/components/profile/documents/types/PersonProfileType';
import OrganizationProfileType from '@/components/profile/documents/types/OrganizationProfileType';
import { AuthModule } from '@/store/modules/auth';

export default {
  name: 'DocumentsAndData',
  components: { OrganizationProfileType, PersonProfileType },
  data: () => ({
    mdiCheckCircleOutline,
    type: 'person',
  }),
  computed: {
    componentName() {
      return AuthModule.isOrganization
        ? 'OrganizationProfileType'
        : 'PersonProfileType';
    },
  },
};
</script>

<style lang="scss">
.profile-user-view {
  & .note {
    width: 420px;
    @media screen and (max-width: $gr-sm) {
      width: 100%;
      max-width: unset;
    }
  }

  .card {
    padding: 30px 28px;
    border-radius: 0;
    box-shadow: none;
    width: 100%;

    @media screen and (max-width: $gr-md) {
      padding-left: 15px;
    }

    .v-sheet.v-card {
      border-radius: 0 !important;
    }

    & .title {
      font-weight: 600;
      color: $color-base;
      font-size: $font-size-base !important;
    }

    & .text {
      color: $color-base;
      font-size: $font-size-small;
      margin-bottom: 12px;
    }

    & .diver {
      margin: 12px 0;
    }

    & .icon {
      margin-right: 14px;
    }

    & .title-box {
      &--flex {
        display: flex;
        align-items: center;
        flex-direction: row;
      }
    }
  }

  .card-user {
    & .info-box {
      display: flex;
      width: 100%;
      flex-direction: column;
      padding-left: 40px;

      @media screen and (max-width: $gr-md) {
        padding-left: 20px;
      }
    }
  }

  .card {
    margin-bottom: 25px;
  }

  & .row {
    & .col-12:nth-child(odd) {
      padding-right: 12px;
      padding-left: 0;
      @media screen and (max-width: $gr-md) {
        padding-left: 0;
        padding-right: 0;
      }
    }

    & .col-12:nth-child(even) {
      padding-left: 12px;
      padding-right: 0;
      @media screen and (max-width: $gr-md) {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }
}
</style>
